export function initialize(module: ng.IModule) {
    module.directive("confirmButtons", confirmButtonsDirective);
}

function confirmButtonsDirective() : ng.IDirective {
    return {
        scope: {
            okText: "@",
            cancelText: "@",
            okAction: "&",
            cancelAction: "&"
        },
        restrict: "A",
        template: require("./confirmbuttons.directive.html")
    }
}

import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CrewPermissionsService } from './crew-permissions.service';

@Component({
    selector: "crew-confirm-buttons",
    template: require('./confirm-buttons.component.html')
})
export class ConfirmButtons {

    isPermissionWriteOrAdmin: boolean;

    constructor(crewPermissionsService: CrewPermissionsService) {
        // default values
        this.okText = "Ok";
        this.cancelText = "Cancel"; 
        this.backToListText = "Back to list"
        this.isBackToListVisible = true;

        crewPermissionsService.isPermissionWriteOrAdmin().subscribe(value => this.isPermissionWriteOrAdmin = value);
    }

    @Input()
    okText: string;

    @Input()
    cancelText: string;

    @Input()
    isBackToListVisible: boolean;

    @Input()
    backToListText: string;

    @Output()
    onOk = new EventEmitter();

    @Output()
    onCancel = new EventEmitter();

    @Output()
    onBackToList = new EventEmitter();

    ok() {
        this.onOk.emit();
    }

    cancel() {
        this.onCancel.emit();
    }

    backToList() {
        this.onBackToList.emit();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/confirmbuttons.directive.ts